import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cv-point-store-product-landing-list',
  templateUrl: './point-store-product-landing-list.component.html',
  styleUrls: ['./point-store-product-landing-list.component.scss']
})
export class PointStoreProductLandingListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
